module.exports = __webpack_public_path__ + "img/icon-profile-program-active.1dc88a50.svg";